<template>
    <div class="m-20">
        <div style="margin-top: 20px; border: 1px solid #ccc; height: 800px">
            <iframe
                v-if="pdfUrl"
                :src="pdfUrl"
                width="100%"
                height="100%"
            ></iframe>
        </div>
    </div>
    <div class="hidden">
        <whiteboard sport="american-football" is-play="true"> </whiteboard>
    </div>
</template>

<script>
import emitter from "tiny-emitter/instance";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

export default {
    name: "PdfPreview",
    data() {
        return {
            pdfUrl: null,
        };
    },
    mounted() {
        setTimeout(() => {
            this.generatePdf();
        }, 2000);
    },
    methods: {
        async generatePdf() {
            const resp = await axios.get(
                "/plays/list-by-playbook-api?teamId=2&playbookId=20"
            );
            const plays = resp.data;

            // Helper: convert image URL → base64
            const toBase64 = (url) =>
                new Promise((resolve, reject) => {
                    const img = new Image();
                    img.crossOrigin = "anonymous";
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        resolve(canvas.toDataURL("image/png"));
                    };
                    img.onerror = reject;
                    img.src = url;
                });

            // Get logo base64
            const logoBase64 = await toBase64("/images/logo.png");

            // ---------- COVER PAGE ----------
            const docContent = [
                {
                    text: "Hello world",
                    fontSize: 40,
                    bold: true,
                    alignment: "center",
                    margin: [0, 60, 0, 20],
                },
                {
                    text: "Team Name",
                    fontSize: 20,
                    alignment: "center",
                    margin: [0, 0, 0, 20],
                },
                {
                    image: logoBase64,
                    width: 120,
                    alignment: "center",
                    margin: [0, 20, 0, 60],
                },
                { text: "", pageBreak: "after" },
            ];

            // ---------- EACH PLAY PAGE ----------
            for (const play of plays) {
                console.log("GENERATING " + play.play_id);
                const resp = await axios.get("/plays/get-play-data", {
                    params: { play_id: play.play_id },
                });
                play.play_json = resp.data.play_json;

                console.log("WHYYY 1");
                const wbImage = await this.getPlayImage(play, "dataURL");
                if (!wbImage?.image) continue;
                console.log("WHYYY 2");

                const playPage = [
                    {
                        text: play.play_name,
                        fontSize: 24,
                        bold: true,
                        alignment: "center",
                        margin: [0, 10, 0, 20],
                    },
                    {
                        image: wbImage.image, // already base64
                        width: 545.28,
                        alignment: "center",
                        margin: [0, 0, 0, play.play_note ? 20 : 0],
                    },
                ];
                console.log("WHYYY 3");

                if (play.play_note) {
                    play.play_note = play.play_note.replaceAll(
                        "<hr><hr><hr>",
                        "<hr>"
                    );
                    play.play_note = play.play_note.replaceAll(
                        "<hr><hr>",
                        "<hr>"
                    );
                    // ✅ Convert HTML to pdfmake content
                    const playNotePdfmake = htmlToPdfmake(play.play_note, {
                        defaultStyles: {
                            p: {
                                fontSize: 8,
                            },
                        },
                    });

                    playPage.push({
                        stack: [
                            {
                                text: "Notes",
                                fontSize: 16,
                                bold: true,
                                margin: [0, 10, 0, 8],
                            },
                            playNotePdfmake,
                        ],
                        margin: [40, 0, 40, 0],
                    });
                }

                // Add a page break after each play (except last)
                playPage.push({ text: "", pageBreak: "after" });

                docContent.push(...playPage);
            }

            // ---------- FOOTER ----------
            const now = new Date().toLocaleString();
            const docDefinition = {
                pageSize: "A4",
                pageMargins: [40, 60, 40, 60],
                content: docContent,
                footer: (currentPage, pageCount) => {
                    return {
                        columns: [
                            {
                                text: `Printed on ${now}`,
                                alignment: "left",
                                fontSize: 10,
                                margin: [40, 0, 0, 10],
                            },
                            {
                                image: logoBase64,
                                fit: [40, 10],
                                alignment: "right",
                                margin: [0, 0, 40, 10],
                            },
                        ],
                    };
                },
            };

            // ---------- GENERATE ----------
            pdfMake.createPdf(docDefinition).open();
            // or .download("playbook.pdf");
        },
        getPlayImage(play, mode) {
            return new Promise((resolve, reject) => {
                emitter.once("getBufferDataReplyFull", (e) => {
                    resolve(e);
                });
                emitter.emit("wb-change-background", play.background);

                emitter.emit("wb-load-play", play);
                setTimeout(() => {
                    emitter.emit("getBufferDataFull", mode);
                }, 1000);
            });
        },
    },
};
</script>
